import * as _ from 'underscore';
import * as jsonpath from 'jsonpath';
import { SimulatorService } from "./simulator.service"
import { Http, Headers } from "@angular/http"
import { Injectable } from '@angular/core';
import { UtilitiesService } from "./utilities.service"
//import systemjs from 'systemjs';
import { SimulatorFrameComponent } from "../components/simulator-frame.component"
//import { SampleService } from './ .service';
import { SenderType, InputType, ANAChatMessage, MessageType, InputContent, LocationInput, DateInput, TimeInput, AddressInputField, MediaInput, MediaType, TextInput, ListInputContent, CarouselContent, ANAMessageData, ANAMeta, SimpleContent, OptionsInputContent, DateInputContent, MediaInputContent, AddressInputContent, LocationInputContent, TextInputContent, ListItem, IANAChatMessage } from '../models/ana-chat.models';
import { SampleService } from './resolver.service';



export enum VariableType {
    Array, String, Object, Other
}

export enum ButtonType {
    ACTION = 2,
    QUICK_REPLY = 1,
    URL = 0
}

//////////////////////////////////////////





///////////////////////////////////////////



///////////////////////////////////////////
export enum SectionType {
    Image = 'Image',
    Text = 'Text',
    Graph = 'Graph',
    Gif = 'Gif',
    Audio = 'Audio',
    Video = 'Video',
    Link = 'Link',
    EmbeddedHtml = 'EmbeddedHtml',
    Carousel = 'Carousel',
    PrintOTP = 'PrintOTP'
}

export enum CarouselButtonType {
    NextNode = 'NextNode',
    DeepLink = 'DeepLink',
    OpenUrl = 'OpenUrl'
}

export enum NodeType {
    ApiCall = 'ApiCall',
    Combination = 'Combination',
    Card = 'Card',
    JumpToBot = 'JumpToBot',
    Condition = 'Condition',
    HandoffToAgent = 'HandoffToAgent'
}

export enum APIMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    HEAD = 'HEAD',
    OPTIONS = 'OPTIONS',
    CONNECT = 'CONNECT',
}

export enum CardPlacement {
    Incoming = 'Incoming',
    Outgoing = 'Outgoing',
    Center = 'Center'
}
//Enums End

// Sections - Start
export interface TitleCaptionEntity {
    Title?: string;
    Caption?: string;
}

export interface BaseIdEntity {
    _id: string;
}

export interface BaseEntity extends BaseIdEntity { }

export interface Section extends BaseEntity {
    SectionType: SectionType;
    DelayInMs?: number;
    Hidden?: boolean;

    ContentId?: string;
    ContentEmotion?: string;
}

export interface RepeatableBaseEntity extends BaseEntity {
    DoesRepeat?: boolean;
    RepeatOn?: string;
    RepeatAs?: string;
    StartPosition?: string;
    MaxRepeats?: number;
}

export interface TextSection extends Section {
    Text: string;
}

export interface TitleCaptionSection extends Section, TitleCaptionEntity { }

export interface TitleCaptionUrlSection extends TitleCaptionSection {
    Url: string;
}

export interface ImageSection extends TitleCaptionUrlSection { }

export interface VideoSection extends TitleCaptionUrlSection { }

export interface AudioSection extends TitleCaptionUrlSection { }

export interface EmbeddedHtmlSection extends TitleCaptionUrlSection { }

export interface CarouselButton extends RepeatableBaseEntity {
    Url?: string;
    Type?: CarouselButtonType;
    VariableValue?: string;
    NextNodeId?: string;
    Text?: string;

    ContentId?: string;
    ContentEmotion?: string;
}

export interface CarouselItem extends RepeatableBaseEntity, TitleCaptionEntity {
    ImageUrl?: string;
    Buttons?: CarouselButton[];

    ContentId?: string;
    ContentEmotion?: string;
}

export interface CarouselSection extends TitleCaptionSection {
    Items: CarouselItem[];
}
// Sections - End
export enum ConditionOperator {
    EqualTo = 'EqualTo',
    NotEqualTo = 'NotEqualTo',
    GreaterThan = 'GreaterThan',
    LessThan = 'LessThan',
    GreaterThanOrEqualTo = 'GreaterThanOrEqualTo',
    LessThanOrEqualTo = 'LessThanOrEqualTo',
    Mod = 'Mod',
    In = 'In',
    NotIn = 'NotIn',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    Contains = 'Contains',
    Between = 'Between',
    IsNull = 'IsNull'
}

export enum ButtonType {
    OpenUrl = 'OpenUrl',
    GetText = 'GetText',
    GetNumber = 'GetNumber',
    GetAddress = 'GetAddress',
    GetEmail = 'GetEmail',
    GetPhoneNumber = 'GetPhoneNumber',
    GetItemFromSource = 'GetItemFromSource',
    GetImage = 'GetImage',
    GetAudio = 'GetAudio',
    GetVideo = 'GetVideo',
    NextNode = 'NextNode',
    DeepLink = 'DeepLink',
    GetAgent = 'GetAgent',
    GetFile = 'GetFile',
    ShowConfirmation = 'ShowConfirmation',
    FetchChatFlow = 'FetchChatFlow',
    /// Format: yyyy-MM-dd
    GetDate = 'GetDate',
    /// Format: HH:mm:ss
    GetTime = 'GetTime',
    /// Format: yyyy-MM-ddTHH:mm:ss
    GetDateTime = 'GetDateTime',
    /// Format: [Latitude],[Longitude]
    GetLocation = 'GetLocation'
}

export interface Button extends BaseIdEntity {
    ButtonName: string;
    ButtonText?: string;
    Emotion?: number;
    ButtonType: ButtonType;
    DeepLinkUrl?: string;
    Url?: string;
    ItemsSource?: string;
    AllowMultiple?: boolean;

    BounceTimeout?: number;
    NextNodeId?: string;
    DefaultButton?: boolean;
    Hidden?: boolean;
    VariableValue?: string;
    PrefixText?: string;
    PostfixText?: string;
    PlaceholderText?: string;
    ConditionMatchKey?: string;
    ConditionOperator?: ConditionOperator;
    ConditionMatchValue?: string;
    PostToChat?: boolean;
    DoesRepeat?: boolean;
    RepeatOn?: string;
    RepeatAs?: string;
    StartPosition?: number;
    MaxRepeats?: number;
    AdvancedOptions?: boolean;
    MinLength?: number;
    MaxLength?: number;
    DefaultText?: string;
    IsMultiLine?: boolean;

    ContentId?: string;
    ContentEmotion?: string;
}

export interface ChatNode {
    Name: string;
    Id: string;
    Emotion?: string;
    NodeType: NodeType;
    Sections: Section[];
    Buttons: Button[];
    VariableName?: string;
    ApiMethod?: APIMethod;
    ApiUrl?: string;
    ApiResponseDataRoot?: string;
    NextNodeId?: string;
    RequiredVariables?: string[];
    GroupName?: string;
    CardHeader?: string;
    CardFooter?: string;
    Placement?: CardPlacement;
    IsStartNode?: boolean;
    IsGoalNode?: boolean;
    TargetBotId?: string;
    TargetNodeId?: string;

    RequestBody?: string;
    Headers?: string;
}

export interface ChatContent {
    ButtonId: string;
    ButtonText: string;
    NodeName?: string;
    NodeId: string;
    Emotion?: string;
    CreatedOn: Date;
    UpdatedOn: Date;
    _id?: string;
    SectionText: string;
    SectionId: string;
    Title: string;
    Caption: string;
}

//WebNodeLocations: NodeLocations;
export interface ChatFlowPack {
    ProjectId: string;
    ChatNodes: ChatNode[];
    NodeLocations?: NodeLocations;
    CreatedOn: Date;
    UpdatedOn: Date;
    _id: string;
}

export interface NodeLocations {
    [key: string]: LayoutPoint;
}

export interface LayoutPoint {
    X: number;
    Y: number;
}

export enum EditorType {
    Text = 'Text',
    TitleCaptionUrl = 'TitleCaptionUrl',
    Carousel = 'Carousel'
}

export class ModelHelpers {
    constructor(
        // public globalsService: GlobalsService
        //public infoDialog: InfoDialogService
    ) {

    }

    CarouselButtonType = CarouselButtonType;

    carouselButtonTypes: CarouselButtonType[] = [
        CarouselButtonType.NextNode,
        CarouselButtonType.OpenUrl,
    ];

    nodeTypes: NodeType[] = [
        NodeType.ApiCall,
        NodeType.Combination,
        //NodeType.Card,
        NodeType.Condition,
        NodeType.HandoffToAgent,
        NodeType.JumpToBot
    ];
    apiMethods: APIMethod[] = [
        APIMethod.GET,
        APIMethod.POST,
        APIMethod.PUT,
        APIMethod.HEAD,
        APIMethod.OPTIONS,
        APIMethod.DELETE,
        APIMethod.CONNECT
    ];
    cardPlacements: CardPlacement[] = [
        CardPlacement.Center,
        CardPlacement.Incoming,
        CardPlacement.Outgoing,
    ];
    buttonTypes: ButtonType[] = [
        ButtonType.DeepLink,
        //ButtonType.FetchChatFlow,
        ButtonType.GetAddress,
        //ButtonType.GetAgent,
        ButtonType.GetAudio,
        ButtonType.GetDate,
        //ButtonType.GetDateTime,
        ButtonType.GetEmail,
        ButtonType.GetImage,
        ButtonType.GetItemFromSource,
        ButtonType.GetLocation,
        ButtonType.GetNumber,
        ButtonType.GetPhoneNumber,
        ButtonType.GetText,
        ButtonType.GetTime,
        ButtonType.GetVideo,
        ButtonType.GetFile,
        ButtonType.NextNode,
        ButtonType.OpenUrl,
        //ButtonType.ShowConfirmation
    ];
    conditionOperators: ConditionOperator[] = [
        ConditionOperator.EqualTo,
        ConditionOperator.NotEqualTo,
        ConditionOperator.GreaterThan,
        ConditionOperator.LessThan,
        ConditionOperator.GreaterThanOrEqualTo,
        ConditionOperator.LessThanOrEqualTo,
        ConditionOperator.Mod,
        ConditionOperator.In,
        ConditionOperator.NotIn,
        ConditionOperator.StartsWith,
        ConditionOperator.EndsWith,
        ConditionOperator.Contains,
        ConditionOperator.Between,
        ConditionOperator.IsNull
    ];
    sectionAlias(section: Section) {
        switch (section.SectionType) {
            case SectionType.Text:
                {
                    let ts = section as TextSection;
                    return ts.Text || ts.SectionType;
                }
            case SectionType.Image:
            case SectionType.Audio:
            case SectionType.Video:
            case SectionType.EmbeddedHtml:
            case SectionType.Gif:
            case SectionType.Graph:
            case SectionType.Carousel:
                {
                    let tcs = section as TitleCaptionSection;
                    return tcs.Title || tcs.Caption || tcs.SectionType;
                }
            default:
                return section.SectionType;
        }
    }
    chatButtonAlias(btn: Button) {
        return btn.ButtonName || btn.ButtonText || btn.ButtonType;
    }

    editorTypeFromSectionType(secType: SectionType): EditorType {
        switch (secType) {
            case SectionType.Text:
                return EditorType.Text;
            case SectionType.Image:
            case SectionType.Audio:
            case SectionType.Video:
            case SectionType.Gif:
            case SectionType.PrintOTP:
            case SectionType.EmbeddedHtml:
                return EditorType.TitleCaptionUrl;
            case SectionType.Carousel:
                return EditorType.Carousel;
            default:
                return EditorType.Text;
        }
    }
}

///////////////////////////////////////////////////////////////////////
@Injectable()
export class SimulatorFromStudio {

    private debug: boolean = true;
    private chatFlow: ChatNode[] = [];
    private state: SimulatorState;
    private simulatorFrame: SimulatorFrameComponent;
    //private sample: SampleService
    public simulatorBusinessId = 'ana-studio';
    public simulatorCustomerId = 'ana-simulator';

    constructor(private globals: UtilitiesService, private http: Http) {
        // window.onmessage = (event) => {
        //     this.logDebug('On message received from client:');
        //     this.logDebug(event.data);
        //     let msg = event.data as SimulatorMessage;
        //     if (msg.type == SimulatorMessageType.AnaChatMessage) {
        //         let cfMsg = (msg as AnaChatSimulatorMessage);
        //         this.handleIncomingMessage(cfMsg.data);
        //     }
        // }
    }

    onMessage(event) {
        this.logDebug('On message received from client:');
        this.logDebug(event.data);
        let msg = event as SimulatorMessage;
        //debugger
        if (msg.type == SimulatorMessageType.AnaChatMessage) {
            let cfMsg = (msg as AnaChatSimulatorMessage);

            this.handleIncomingMessage(cfMsg.data);
        }
    }

    public getJSON(url) {
        return this.http.get(url).map(res=>res.json());
    }

    init(url: string) {
        let chatdata: {
             ChatNodes;
        };

        this.getJSON(url).subscribe(resData => {
            chatdata = resData;
            //debugger
            this.chatFlow = chatdata.ChatNodes;
            //this.chatFlow = []            
            //console.log("chat nodes" + JSON.stringify(this.chatFlow))
            if (this.chatFlow && this.chatFlow.length > 0) {
                this.state = {
                    variables: {}
                };
                this.pushResetToClient();
                let firstMsg: any = {
                    "meta": {
                        "sender": {
                            "id": this.simulatorBusinessId,
                            "medium": 100
                        },
                        "recipient": {
                            "id": this.simulatorCustomerId,
                            "medium": 100
                        },
                        "senderType": SenderType.USER,
                        "timestamp": new Date().getTime(),
                    },
                    "data": {
                        "type": 2,
                        "content": {
                            "inputType": InputType.OPTIONS,
                            "mandatory": 1,
                            "options": [
                                {
                                    "title": "Get Started",
                                    "value": "GetStarted"
                                }
                            ],
                            "input": {
                                "val": "GET_STARTED"
                            }
                        }
                    }
                };
                this.handleIncomingMessage(firstMsg);
            }
        });

    }

    handleIncomingMessage(message: IANAChatMessage) {
        this.logDebug("Incoming message from client: ");
        this.logDebug(message);
        this.processIncomingMessage(message);
    }

    pushMessageToClient(message: IANAChatMessage) {
        let resp: AnaChatSimulatorMessage = {
            data: message,
            type: SimulatorMessageType.AnaChatMessage
        };
        SampleService.onMessage(resp)

    }

    pushResetToClient() {
        //console.log("simulator msg type" + SimulatorMessageType.AnaChatReset)
        SampleService.onMessage({
            type: SimulatorMessageType.AnaChatReset
        })

    }

    private processIncomingMessage(chatMsg: IANAChatMessage) {
        let message = chatMsg.data;
        if (message.type == MessageType.INPUT) {
            let ipMsgContent = message.content as InputContent;
            if (ipMsgContent.input && Object.keys(ipMsgContent.input).length > 0) {
                let nextNodeId = "";
                let userData: any = null;
                switch (ipMsgContent.inputType) {
                    case InputType.LOCATION://Click, Complex
                        {
                            let locIp = ipMsgContent.input as LocationInput;
                            userData = UtilitiesService.anaLocationDisplay(locIp.location);
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetLocation);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.DATE://Click, Complex
                        {
                            let ip = ipMsgContent.input as DateInput;
                            userData = UtilitiesService.anaDateDisplay(ip.date);
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetDate);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.TIME://Click, Complex
                        {
                            let ip = ipMsgContent.input as TimeInput;
                            userData = UtilitiesService.anaTimeDisplay(ip.time);
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetTime);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.ADDRESS://Click, Complex
                        {
                            let ip = ipMsgContent.input as AddressInputField;
                            userData = UtilitiesService.anaAddressDisplay(ip.address);
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetAddress);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.MEDIA: //Click, Non Complex
                        {
                            let ip = ipMsgContent.input as MediaInput;
                            if (ip.media && ip.media.length > 0 && ip.media[0]) {

                                if (typeof ip.media[0].url == 'object')
                                    userData = (<any>ip.media[0].url).changingThisBreaksApplicationSecurity;
                                else
                                    userData = ip.media[0].url;
                                let cfmType = ButtonType.GetFile;
                                switch (ip.media[0].type) {
                                    case MediaType.AUDIO:
                                        cfmType = ButtonType.GetAudio;
                                        break;
                                    case MediaType.VIDEO:
                                        cfmType = ButtonType.GetVideo;
                                        break;
                                    case MediaType.IMAGE:
                                        cfmType = ButtonType.GetImage;
                                        break;
                                    case MediaType.FILE:
                                    default:
                                        cfmType = ButtonType.GetFile;
                                        break;
                                }
                                let clickedBtn = this.getNodeButtonByType(cfmType);
                                if (clickedBtn)
                                    nextNodeId = clickedBtn.NextNodeId;
                            }
                        }
                        break;
                    case InputType.OPTIONS: //Click, Non Complex
                        {
                            let ip = ipMsgContent.input as TextInput; //Option also has input.val
                            // console.log(JSON.stringify(ip)+"////////")
                            if (ip.val == "GET_STARTED") {
                                let firstNode = _.first(this.chatFlow.filter(x => {if(x.IsStartNode==true)return x;}));
                                nextNodeId = (firstNode ? firstNode.Id : this.chatFlow[0].Id);
                                // console.log(nextNodeId+"////////////////")
                            } else {
                                let clickedBtn = this.getNodeButtonById(ip.val);
                                if (clickedBtn) {
                                    nextNodeId = clickedBtn.NextNodeId;
                                    userData = clickedBtn.VariableValue;
                                }
                            }
                        }
                        break;
                    case InputType.LIST://Click, Complex
                        {
                            let ipMsg = ipMsgContent as ListInputContent;
                            let ip = ipMsg.input;
                            let listSelectedValues = ip.val.split(',');
                            let listSelectedItems = ipMsg.values.filter(x => listSelectedValues.indexOf(x.value) != -1);
                            userData = ip.val;//listSelectedItems.map(x => x.text);
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetItemFromSource);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.PHONE:
                        {
                            let ip = ipMsgContent.input as TextInput;
                            userData = ip.val;
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetPhoneNumber);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.EMAIL:
                        {
                            let ip = ipMsgContent.input as TextInput;
                            userData = ip.val;
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetEmail);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.NUMERIC:
                        {
                            let ip = ipMsgContent.input as TextInput;
                            userData = ip.val;
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetNumber);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    case InputType.TEXT:
                        {
                            let ip = ipMsgContent.input as TextInput;
                            userData = ip.val;
                            let clickedBtn = this.getNodeButtonByType(ButtonType.GetText);
                            if (clickedBtn)
                                nextNodeId = clickedBtn.NextNodeId;
                        }
                        break;
                    default:
                        break;
                }
                //console.log("next node" + nextNodeId)
                this.saveVariable(userData);
                this.gotoNextNode(nextNodeId);
            }
        } else if (message.type == MessageType.CAROUSEL) {
            let msgContent = message.content as CarouselContent;
            if (msgContent.input && Object.keys(msgContent.input).indexOf('val') != -1 && msgContent.input.val) {
                let clickedCarBtn = this.getCarouselButtonById(msgContent.input.val);
                this.saveVariable(clickedCarBtn.VariableValue);
                switch (clickedCarBtn.Type) {
                    case CarouselButtonType.DeepLink:
                    case CarouselButtonType.OpenUrl:
                    case CarouselButtonType.NextNode:
                    default:
                        this.gotoNextNode(clickedCarBtn.NextNodeId);
                        break;
                }
            }
        }
    }

    private gotoNextNode(nextNodeId: string) {
        let nextNode = this.getNodeById(nextNodeId);
        if (nextNode)
            this.processNode(nextNode);
    }

    private getNodeById(Id: string) {
        if (Id) {
            let foundNodes = this.chatFlow.filter(n => n.Id == Id);
            if (foundNodes && foundNodes.length > 0)
                return foundNodes[0];
        }
        return null;
    }

    private getNodeButtonById(buttonId: string) {
        let btn = this.state.currentNode.Buttons.filter(x => x._id == buttonId);
        return (btn && btn.length > 0) ? btn[0] : null;
    }

    private getNodeButtonByType(type: ButtonType) {
        let btn = this.state.currentNode.Buttons.filter(x => x.ButtonType == type);
        let firstTry = (btn && btn.length > 0) ? btn[0] : null;
        if (firstTry) return firstTry;

        if (type == ButtonType.GetText) {
            let found = _.first(_.filter(this.state.currentNode.Buttons, x => _.contains([
                ButtonType.GetPhoneNumber,
                ButtonType.GetEmail,
                ButtonType.GetNumber
            ], x.ButtonType)));
            if (found) return found;
        }
        return null;
    }

    private getCarouselButtonById(carItemBtnId: string) {
        let carSection = this.state.currentSection as CarouselSection;
        if (carSection && carSection.SectionType == SectionType.Carousel) {
            let carBtn = carSection.Items.map(x => x.Buttons).reduce((a, b) => (a && a.length > 0 && b && b.length > 0) ? a.concat(b) : []).filter(x => x._id == carItemBtnId);
            return (carBtn && carBtn.length > 0) ? carBtn[0] : null;
        }
        return null;
    }

    private saveVariable(value: string) {
        if (value && this.state.currentNode && this.state.currentNode.VariableName)
            this.state.variables[this.state.currentNode.VariableName] = value;
    }

    private logDebug(msg: any) {
        if (this.debug)
            console.log(msg);
    }

    private processVerbsForChatNode(chatNode: ChatNode): ChatNode {
        return JSON.parse(this.processVerbs(JSON.stringify(chatNode))) as ChatNode;
    }

    private replaceTxt(subStr, key) {
        if (!key)
            key = subStr.replace('{{', '').replace('}}', '');

        try {
            if (this.state.variables && this.state.variables[key])
                return this.state.variables[key];
            else {
                let rootToken = key.split(/\.|\[/)[0];
                let wrappedResp = {};
                wrappedResp[rootToken] = JSON.parse(this.state.variables[rootToken]);
                let deepValue: any = jsonpath.query(wrappedResp, key);
                if (deepValue && typeof deepValue == 'object' && deepValue.length == 1) {
                    deepValue = deepValue[0];
                }
                return deepValue;
            }
        } catch (e) {
            return subStr;
        }
    }

    private jsonEscape(value: any) {
        if (value && (typeof value == "string") && value.replace) {
            let rTxt = value
                .replace(/\n/g, "\\n")
                //.replace(/\'/g, "\\'")
                .replace(/\"/g, '\\"')
                .replace(/\&/g, "\\&")
                .replace(/\r/g, "\\r")
                .replace(/\t/g, "\\t")
                .replace(/\f/g, "\\f");
            return rTxt;
        }
        return value;
    }

    private processVerbs(txt: string): string {
        let processedText = txt.replace(/\[~(.*?)\]|{{(.*?)}}/g, (subStr, key) => {
            return this.jsonEscape(this.replaceTxt(subStr, key));
        });
        return processedText;
    }

    private processNode(chatNode: ChatNode, section?: Section) {

        chatNode = this.processVerbsForChatNode(chatNode);
        this.state.currentNode = chatNode;
        this.state.currentSection = section || _.first(chatNode.Sections);

        switch (chatNode.NodeType) {
            case NodeType.ApiCall:
                {
                    let apiHeaders = new Headers();

                    if (chatNode.Headers) {
                        let splits = chatNode.Headers.split(/\n|,/);
                        for (var si = 0; si < splits.length; si++) {
                            try {
                                let split = splits[si];
                                if (split.indexOf(':') != -1) {
                                    let key = split.split(':')[0];
                                    let value = split.split(':')[1];
                                    apiHeaders.set(key, value);
                                }
                            } catch (e) {
                                this.logDebug('Invalid format provided in headers');
                                this.logDebug(e);
                            }
                        }
                    }

                    let reqBody: string = null;
                    if (chatNode.RequestBody)
                        reqBody = this.processVerbs(chatNode.RequestBody);

                    let reqParams = new URLSearchParams();
                    if (chatNode.RequiredVariables) {
                        for (var i = 0; i < chatNode.RequiredVariables.length; i++) {
                            if (chatNode.RequiredVariables[i] && Object.keys(this.state.variables).indexOf(chatNode.RequiredVariables[i]) != -1)
                                reqParams.append(chatNode.RequiredVariables[i], this.state.variables[chatNode.RequiredVariables[i]]);
                        }
                    }

                    let nextNodeId = chatNode.NextNodeId;
                    this.http.request(chatNode.ApiUrl, {
                        headers: apiHeaders,
                        body: reqBody,
                        method: APIMethod[chatNode.ApiMethod],
                        params: reqParams,
                    }).subscribe(res => {
                        this.saveVariable(res.text());
                        this.processConditionNode(chatNode);
                    }, err => {
                        if (Math.trunc(err.status / 100) == 5 || typeof err._body == 'object') { //Only 5xx errors are counted as errors
                            this.logDebug(err);
                            this.gotoNextNode(nextNodeId); //Fallback node
                        } else {
                            this.saveVariable(err._body);
                            this.processConditionNode(chatNode);
                        }
                    });
                }
                break;
            case NodeType.Card:
                break;
            case NodeType.Condition:
                this.processConditionNode(chatNode);
                break;

            case NodeType.Combination:
            default:
                {
                    if (chatNode.Sections && chatNode.Sections.length > 0) {
                        let msg = this.convertSection(this.state.currentSection);
                        this.prepareReplyAndSend(msg);
                        let sectionIndex = chatNode.Sections.findIndex(x => x._id == this.state.currentSection._id);
                        let remainingSections = chatNode.Sections.length - (sectionIndex + 1);
                        if (remainingSections > 0) {
                            this.processNode(chatNode, chatNode.Sections[sectionIndex + 1]);
                            return;
                        }
                    }

                    if (this.state.currentNode && this.state.currentNode.Buttons && this.state.currentNode.Buttons.length > 0) {
                        this.convertButtons(this.state.currentNode, (inputMsgToSend) => {
                            this.prepareReplyAndSend(inputMsgToSend);
                        });
                    }
                }
                break;
        }
    }

    private prepareReplyAndSend(data: ANAMessageData) {
        let meta: ANAMeta = {
            id: UtilitiesService.uuidv4(),
            recipient: {
                id: this.simulatorBusinessId,
                medium: 100
            },
            sender: {
                id: this.simulatorCustomerId,
                medium: 100
            },
            senderType: SenderType.ANA,
            sessionId: '1234',
            timestamp: new Date().getTime(),
            responseTo: '',
        };
        this.pushMessageToClient({
            meta: meta,
            data: data,

        });
    }

    private convertSection(section: Section): ANAMessageData {
        let anaMessageContent: SimpleContent = {
            text: ''
        };
        let anaMessageData: ANAMessageData = {
            content: anaMessageContent,
            type: MessageType.SIMPLE
        };
        switch (section.SectionType) {
            case SectionType.Image:
                anaMessageContent.media = {
                    type: MediaType.IMAGE,
                    url: (section as ImageSection).Url,
                }
                anaMessageContent.text = (section as ImageSection).Title;
                break;
            case SectionType.Text:
            default:
                anaMessageContent.text = (section as TextSection).Text;
                break;
            case SectionType.Gif:
                anaMessageContent.media = {
                    type: MediaType.IMAGE,
                    url: (section as ImageSection).Url,
                }
                anaMessageContent.text = (section as ImageSection).Title;
                break;
            case SectionType.Audio:
                anaMessageContent.media = {
                    type: MediaType.AUDIO,
                    url: (section as AudioSection).Url,
                }
                anaMessageContent.text = (section as AudioSection).Title;
                break;
            case SectionType.Video:
                anaMessageContent.media = {
                    type: MediaType.VIDEO,
                    url: (section as VideoSection).Url,
                }
                anaMessageContent.text = (section as VideoSection).Title;
                break;
            case SectionType.Carousel:
                {
                    let carContent: CarouselContent = {
                        items: _.map((section as CarouselSection).Items, x => {
                            return {
                                title: x.Title,
                                desc: x.Caption,
                                media: {
                                    type: MediaType.IMAGE,
                                    url: x.ImageUrl
                                },
                                options: _.map(x.Buttons, y => {
                                    if (y.Type == CarouselButtonType.NextNode) {
                                        return {
                                            title: y.Text,
                                            value: y._id,
                                            type: this.convertCarouselButtonType(y.Type)
                                        };
                                    } else {
                                        return {
                                            title: y.Text,
                                            value: JSON.stringify({
                                                url: y.Url,
                                                value: y._id
                                            }),
                                            type: this.convertCarouselButtonType(y.Type)
                                        };
                                    }
                                }),
                                url: ''
                            };
                        }),
                        mandatory: 1
                    };
                    anaMessageData = {
                        type: MessageType.CAROUSEL,
                        content: carContent
                    };
                }
                break;
        }
        return anaMessageData;
    }

    private convertButtons(chatNode: ChatNode, callback: (resp: ANAMessageData) => void): void {

        let clickInputs = _.filter(chatNode.Buttons, x => _.contains([
            ButtonType.DeepLink,
            ButtonType.OpenUrl,
            ButtonType.GetDate,
            ButtonType.GetImage,
            ButtonType.GetVideo,
            ButtonType.GetAddress,
            ButtonType.GetAudio,
            ButtonType.GetDateTime,
            ButtonType.GetTime,
            ButtonType.GetItemFromSource,
            ButtonType.GetFile,
            ButtonType.GetLocation,
            ButtonType.FetchChatFlow,
            ButtonType.ShowConfirmation,
            ButtonType.NextNode,
        ], x.ButtonType));

        let textInputs = _.filter(chatNode.Buttons, x => _.contains([
            ButtonType.GetText,
            ButtonType.GetEmail,
            ButtonType.GetPhoneNumber,
            ButtonType.GetNumber,
        ], x.ButtonType));

        let mandatory = 1;
        if (textInputs && textInputs.length > 0 && clickInputs && clickInputs.length > 0)
            mandatory = 0;

        if (clickInputs && clickInputs.length > 0) {
            if (_.filter(clickInputs, x => _.contains([ButtonType.NextNode, ButtonType.OpenUrl], x.ButtonType)).length > 0) { //If next node/open url button is present, only options can be sent
                //Build options input and send
                let optionsInput: OptionsInputContent = {
                    inputType: InputType.OPTIONS,
                    mandatory: mandatory,
                    options: _.map(_.filter(clickInputs, x => _.contains([ButtonType.NextNode, ButtonType.OpenUrl], x.ButtonType)), y => {
                        return {
                            title: y.ButtonName || y.ButtonText,
                            value: (y.ButtonType == ButtonType.OpenUrl ? JSON.stringify({ url: y.Url, value: y._id }) : y._id),
                            type: this.convertButtonType(y.ButtonType)
                        }
                    })
                };
                return callback({
                    content: optionsInput,
                    type: MessageType.INPUT
                });
            }

            let inputButton = _.first(clickInputs);
            switch (inputButton.ButtonType) {
                case ButtonType.GetDate:
                    return callback({
                        content: <DateInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.DATE,
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetTime:
                    return callback({
                        content: <DateInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.TIME,
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetVideo:
                    return callback({
                        content: <MediaInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.MEDIA,
                            mediaType: MediaType.VIDEO
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetImage:
                    return callback({
                        content: <MediaInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.MEDIA,
                            mediaType: MediaType.IMAGE
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetAddress:
                    return callback({
                        content: <AddressInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.ADDRESS,
                            requiredFields: [
                                "area",
                                "country",
                                "pin",
                                "city",
                                "state",
                                "line1"
                            ]
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetAudio:
                    return callback({
                        content: <MediaInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.MEDIA,
                            mediaType: MediaType.AUDIO
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetItemFromSource:
                    {
                        if (inputButton.ItemsSource) {
                            let msg: ListInputContent = {
                                inputType: InputType.LIST,
                                multiple: inputButton.AllowMultiple,
                                mandatory: mandatory,
                                values: []
                            };
                            let itemSrc = inputButton.ItemsSource.split(',').map(x => {
                                let y = x.trim().split(':');
                                return { K: y[0], V: y[1] }
                            });
                            itemSrc.forEach(x => msg.values.push({
                                text: x.K,
                                value: x.V,
                                // isSelected:true
                            }));
                            return callback({
                                content: msg,
                                type: MessageType.INPUT
                            });
                        }
                        if (inputButton.Url) {
                            this.http.get(inputButton.Url).subscribe(x => {
                                // let items = x.json() as {
                                //     [key: string]: string;
                                // };
                                let items = x.json() as ListItem[]
                                let itemKeys = Object.keys(items);

                                let msg: ListInputContent = {
                                    inputType: InputType.LIST,
                                    multiple: inputButton.AllowMultiple,
                                    mandatory: mandatory,
                                    values: itemKeys.map(key => {
                                        return {
                                            text: key,
                                            value: items[key]
                                        };
                                    })
                                };

                                return callback({
                                    content: msg,
                                    type: MessageType.INPUT
                                });
                            });
                            return;
                        }
                    }
                case ButtonType.GetFile:
                    return callback({
                        content: <MediaInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.MEDIA,
                            mediaType: MediaType.FILE
                        },
                        type: MessageType.INPUT
                    });
                case ButtonType.GetLocation:
                    return callback({
                        content: <LocationInputContent>{
                            mandatory: mandatory,
                            inputType: InputType.LOCATION,
                        },
                        type: MessageType.INPUT
                    });
                default:
                    break;
            }
        }

        if (textInputs && textInputs.length > 0) {
            let textInput = textInputs[0];
            let inputMsg: TextInputContent = {
                inputType: this.convertButtonTypeToInputType(textInput.ButtonType),
                mandatory: mandatory,
                textInputAttr: {
                    defaultText: textInput.DefaultText,
                    maxLength: textInput.MaxLength,
                    minLength: textInput.MinLength,
                    multiLine: textInput.IsMultiLine ? 1 : 0,
                    placeHolder: textInput.PlaceholderText
                }
            }
            return callback({
                content: inputMsg,
                type: MessageType.INPUT
            });
        }
    }

    private convertButtonTypeToInputType(srcType: ButtonType): InputType {
        switch (srcType) {
            default:
            case ButtonType.GetText:
                return InputType.TEXT;
            case ButtonType.GetEmail:
                return InputType.EMAIL;
            case ButtonType.GetNumber:
                return InputType.NUMERIC;
            case ButtonType.GetPhoneNumber:
                return InputType.PHONE;
        }
    }

    private convertCarouselButtonType(srcType: CarouselButtonType): ButtonType {
        switch (srcType) {
            case CarouselButtonType.DeepLink:
            case CarouselButtonType.OpenUrl:
                return ButtonType.URL;
            case CarouselButtonType.NextNode:
            default:
                return ButtonType.ACTION;
        }
    }

    private convertButtonType(srcType: ButtonType): ButtonType {
        switch (srcType) {
            case ButtonType.DeepLink:
            case ButtonType.OpenUrl:
                return ButtonType.URL;
            case ButtonType.NextNode:
            default:
                return ButtonType.ACTION;
        }
    }

    private processConditionNode(chatNode: ChatNode) {
        let done = false;
        try {
            if (chatNode.Buttons) {
                for (var btnIdx = 0; btnIdx < chatNode.Buttons.length; btnIdx++) {
                    let btn = chatNode.Buttons[btnIdx];
                    let rootToken = btn.ConditionMatchKey.split(/\.|\[/)[0];
                    let wrappedResp = {};
                    wrappedResp[rootToken] = JSON.parse(this.state.variables[rootToken]);
                    let deepValue: any = jsonpath.query(wrappedResp, btn.ConditionMatchKey);
                    if (deepValue && typeof deepValue == 'object' && deepValue.length == 1) {
                        deepValue = deepValue[0];
                    }
                    if (this.match(deepValue, btn.ConditionOperator, btn.ConditionMatchValue)) {
                        this.saveVariable(btn.VariableValue);
                        this.gotoNextNode(btn.NextNodeId);
                        done = true;
                        break;
                    }
                }
            }
        } catch (e) {
            if (chatNode.Buttons) {
                for (var btnIdx = 0; btnIdx < chatNode.Buttons.length; btnIdx++) {
                    let btn = chatNode.Buttons[btnIdx];
                    let leftOperand = this.state.variables[btn.ConditionMatchKey];
                    if (this.match(leftOperand, btn.ConditionOperator, btn.ConditionMatchValue)) {
                        this.saveVariable(btn.VariableValue);
                        this.gotoNextNode(btn.NextNodeId);
                        done = true;
                        break;
                    }
                }
            }
        }
        if (!done)
            this.gotoNextNode(chatNode.NextNodeId); //Fallback node id
    }

    private match(left: any, op: ConditionOperator, right: any) {
        try {
            switch (op) {
                case ConditionOperator.Between:
                    {
                        let r1 = right.split(',')[0];
                        let r2 = right.split(',')[1];

                        return (r1 < left && left < r2);
                    }
                case ConditionOperator.NotEqualTo:
                    return left != right;
                case ConditionOperator.GreaterThan:
                    return left > right;
                case ConditionOperator.LessThan:
                    return left < right;
                case ConditionOperator.GreaterThanOrEqualTo:
                    return left >= right;
                case ConditionOperator.LessThanOrEqualTo:
                    return left <= right;
                case ConditionOperator.In:
                    return right.split(',').indexOf(left) != -1;
                case ConditionOperator.NotIn:
                    return right.split(',').indexOf(left) == -1;
                case ConditionOperator.StartsWith:
                    return left.startsWith(right);
                case ConditionOperator.EndsWith:
                    return left.endsWith(right);
                case ConditionOperator.Contains:
                    return left.indexOf(right) != -1;
                case ConditionOperator.IsNull:
                    return (left == null || left == undefined);
                case ConditionOperator.EqualTo:
                default:
                    return left == right;
            }
        } catch (e) {
            console.log('Invalid operation or operands')
            //this.infoDialog.alert('Invalid operation or operands', e);
        }
    }
}

export interface SimulatorState {
    currentNode?: ChatNode;
    currentSection?: Section;
    variables?: {
        [key: string]: string
    }
}

export enum SimulatorMessageType {
    AnaChatMessage = 'AnaChatMessage', AnaChatReset = 'AnaChatReset'
}
export interface SimulatorMessage {
    type: SimulatorMessageType;
    data: any;
}

export interface AnaChatSimulatorMessage extends SimulatorMessage {
    data: IANAChatMessage;
}



// WEBPACK FOOTER //
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/services/plugin.service.ts